// This component is scoped out of CSS Editing for now, will be added in the future
const semanticClassNames = {
  root: 'gallery',
  galleryItem: 'gallery__item',
} as const;

export default semanticClassNames;
